import { render, staticRenderFns } from "./ModalFacilitador.vue?vue&type=template&id=a249f704&"
import script from "./ModalFacilitador.vue?vue&type=script&lang=js&"
export * from "./ModalFacilitador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports